import React, { useState } from 'react';
import { createContainer } from 'unstated-next';
import { usePhoneNumber } from '../../../../../../../common/hooks/use-phone-number';
import {
  AutomationTemplateChannel,
  AutomationTemplateDefinition,
} from './Templates/TemplateDefinitions';

const useAutomationTemplateContainer = () => {
  const [activeTemplate, setActiveTemplate] = useState<{
    template: AutomationTemplateDefinition;
    channel: AutomationTemplateChannel;
  }>();

  const {
    isSmsSupported: smsSupported,
    hasNumber: smsEnabled,
    performActivationViaModal,
  } = usePhoneNumber();

  const smsDisableReason: React.ReactNode | undefined = smsSupported ? (
    smsEnabled ? undefined : (
      <span>
        <button onClick={performActivationViaModal()}>
          Activate an SMS number
        </button>{' '}
        to enable this feature
      </span>
    )
  ) : (
    <span>SMS not available in your region</span>
  );

  const closeTemplate = () => setActiveTemplate(undefined);

  return {
    activeTemplate,
    setActiveTemplate,
    closeTemplate,
    smsSupported,
    smsEnabled,
    smsDisableReason,
  };
};

export const AutomationTemplateContainer = createContainer(
  useAutomationTemplateContainer,
);
